


























































































import { Component, Vue } from 'vue-property-decorator';
import IssueList from './components/issueList.vue';
import IssueDetail from './components/issueDetail.vue';
import { issueListInstance } from '@/model/IssueListClass';
import { compareObj } from '@/utils/other';
import { TagsViewModule } from '@/store/modules/tagsView';

type IGetIssues = IIssue.IRequest.IGetIssues;
type IIssueStatusTxt = IIssue.IIssueStatus;
type IIssueInfo = IIssue.IResponse.IIssueInfo;
type IUserInfo = IUser.IResponse.IUserDetailInfo;
type ILabelInfo = ILabel.IResponse.ILabelInfo;
type ICreateOrUpdateComment = IComment.IRequest.ICreateOrUpdateComment;


interface ISearchParams {
  keyword?: string;
  status?: IIssue.IIssueStatus;
}

@Component({
  name: 'Issue',
  components: {
    IssueList,
    IssueDetail,
  },
})
export default class Issue extends Vue {
  private searchByKeyword: string = '';
  private searchByStatus: IIssueStatusTxt | 'All' = 'All';
  private issueForSearch: IGetIssues = {};
  private isInitData = false;
  private issueList = issueListInstance;
  private listSpinning = false;
  private detailSpinning = false;
  private addLoading = false;
  private searchStatusOption: Array<IIssueStatusTxt | 'All'> = ['All', 'Request', 'Approved', 'Rejected', 'Cancel', 'Closed'];
  get listData() {
    return this.issueList.list.data;
  }
  get currentIssue() {
    return this.issueList.list.current;
  }
  get activeId() {
    return this.currentIssue?.id || '';
  }
  get isMore() {
    return this.issueList.isMore;
  }
  private created() {
    this.initData();
  }
  private activated() {
    this.initData();
  }
  private initData() {
    if (Object.keys(this.$route.params).length && !compareObj(this.$route.params, this.issueForSearch)) {
      this.issueForSearch = { ...this.$route.params };
      this.handleRefresh();
      this.isInitData = true;
      TagsViewModule.ChangeView({...this.$route, params: {}});
      return;
    }
    if (!this.isInitData) {
      this.initIssues(this.issueForSearch);
      this.isInitData = true;
    }
  }
  private destroyed() {
    issueListInstance.list.clearData();
  }
  private initIssues(params?: IIssue.IRequest.IGetIssues) {
    this.listSpinning = true;
    issueListInstance
      .requestData(params)
      .catch((err) => {
        this.$message.warning(err);
      })
      .finally(() => {
        this.listSpinning = false;
      });
  }
  private getMoreIssues() {
    this.addLoading = true;
    issueListInstance
      .requestMoreData()
      .catch((err) => 'getMoreIssues err' + err)
      .finally(() => {
        this.addLoading = false;
      });
  }
  private issueClick(issue: IIssueInfo) {
    issueListInstance.list.changeCurrent(issue);
  }
  private refreshDetail(issue: IIssueInfo) {
    this.detailSpinning = true;
    issueListInstance
      .requestDetail({id: issue.id})
      .catch((err) => {
        if (err !== 'CANCEL') {
          this.$message.warning(err);
        }
      })
      .finally(() => {
        this.detailSpinning = false;
      });
  }
  private editIssue(issue: IIssueInfo) {
    this.issueList.changeEditItem(issue);
    this.$router.push({
      name: 'UpdateIssue',
    });
  }
  private changeStatus(params: {
    issue: IIssueInfo;
    status: IIssue.IIssueStatus;
  }) {
    issueListInstance.requestUpdateStatus(params.issue, params.status);
  }
  private changeLabel(params: { issue: IIssueInfo; labels: ILabelInfo[] }) {
    this.issueList.updateLabel(params.issue, params.labels);
  }
  private changeComment(params: {
    type: 'ADD' | 'CHANGE';
    issue: IIssueInfo;
    comment: ICreateOrUpdateComment;
  }) {
    const { type, issue, comment } = params;
    this.issueList.updateComment(type, issue, comment);
  }
  private changeReminder(params: { issue: IIssueInfo; reminders: IUserInfo[] }) {
    this.issueList.updateReminder(params.issue, params.reminders);
  }
  private deleteIssue(issueId: string) {
    issueListInstance
      .requestDeleteById(issueId)
      .then((res) => {
        this.$message.success(res);
      })
      .catch((err) => {
        this.$message.warning(err);
      });
  }
  private handleSearch() {
    this.removeIssueForSearch();
    if (this.searchByKeyword.trim() === '' && this.searchByStatus === 'All') {
      this.initIssues();
      return;
    }
    const params: ISearchParams = {};
    if (this.searchByKeyword !== '') {
      params.keyword = this.searchByKeyword;
    }
    if (this.searchByStatus !== 'All') {
      params.status = this.searchByStatus;
    }
    this.initIssues(params);
  }
  private handleRefresh() {
    this.searchByKeyword = '';
    this.searchByStatus = 'All';
    this.initIssues(this.issueForSearch);
  }
  private addIssue() {
    this.$router.push({ name: 'CreateIssue' });
  }
  private removeIssueForSearch() {
    this.issueForSearch = {};
  }
  private removeSearchParams(key: keyof IGetIssues) {
    delete this.issueForSearch[key];
    this.handleRefresh();
  }
}
